module.exports = __webpack_public_path__ + "static/media/loader_gif.ece48b52.gif";